// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__1OrbN","footer":"ChangeClinic_footer__39J7_"};